module.exports = "pegasus/assets/theme5/google-icon.png";